import React from "react";
import Confetti from "react-confetti";

function Confett() {
	return <Confetti width={undefined} height={undefined} />;
}

export default Confett;
